import { getDocumentMetadata } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

import queryKeys from './queryKeys';

export default function documentQueryOptions(id: string) {
  return {
    queryKey: queryKeys.byId(id),
    queryFn: () => getDocumentMetadata({ path: { document_id: id } }, wgApi),
  };
}
